"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Banner = exports.getBannerTypeColor = void 0;
const react_1 = __importDefault(require("react"));
const colors_1 = require("../../../../theme/colors");
const icons_1 = require("../../../../theme/icons");
const Banner_styles_1 = require("./Banner.styles");
const getBannerTypeColor = (type) => {
    switch (type) {
        case "info":
            return colors_1.DARK_GREEN;
        case "warning":
            return colors_1.YELLOW;
        case "error":
            return colors_1.RED;
    }
};
exports.getBannerTypeColor = getBannerTypeColor;
const Banner = ({ children, type, close, show }) => {
    const color = (0, exports.getBannerTypeColor)(type);
    return (react_1.default.createElement(Banner_styles_1.Wrapper, { show: show, type: type },
        react_1.default.createElement(Banner_styles_1.Message, { type: type }, children),
        react_1.default.createElement(Banner_styles_1.CrossStyle, { onClick: close },
            react_1.default.createElement(icons_1.Close, { size: "small", color: color }))));
};
exports.Banner = Banner;
//# sourceMappingURL=Banner.js.map